import vert from "./shaders/zone.vert"
import frag from "./shaders/zone.frag"
import utils from "./shaders/utils.frag"
import spectral from "./shaders/spectral.frag"
import { resize, setup, windowResolution } from "utils"
import { takeScreenshot } from "export"
import { Parameters } from "Parameters"

console.log("By Camille Roux (@CamilleRouxArt)")
console.log("https://art.camilleroux.com/")

// Parameters
let params: Parameters
let mfrag: string
const SIZE_RATIO = 1

// Setup canvas
const canvas = <HTMLCanvasElement>document.createElement("canvas")
document.querySelector("body")?.append(canvas)
const gl = canvas.getContext("webgl2", { preserveDrawingBuffer: true })!
let program: WebGLProgram

// Initial window size
let width = undefined
let height = undefined
let res = windowResolution(SIZE_RATIO, width, height)

window.addEventListener("resize", onResize)
window.addEventListener("keypress", handleKeypress)

function drawArt() {
  // Ensure we use current window dimensions (prevents 0×0 canvas on first draw)
  res = windowResolution(SIZE_RATIO)

  // Recalculate params and mfrag
  params = new Parameters()

  // Add utils shaders function to main frag shader
  const mutils = utils.replace(/^#[\w\s\n]+;/i, "")
  const precision = "precision highp float;"
  mfrag = frag.replace(precision, precision + spectral + mutils)
  mfrag = params.injectParamsToShader(mfrag)

  // Setup WebGL program
  program = setup(vert, mfrag, gl)
  gl.useProgram(program)

  // Set canvas size
  resize(res.width, res.height, gl, program)

  gl.drawArrays(gl.TRIANGLES, 0, 6)
  requestAnimationFrame(() => window.triggerPreview())

  return

  //requestAnimationFrame(draw)
}

// drawArt() // useless when editart code is used

// Make drawArt available globally
window.drawArt = drawArt

function onResize() {
  res = windowResolution(SIZE_RATIO)
  // resize(res.width, res.height, gl, program)
  // if you call drawArt yourself, you have to reset the random number generators first
  window.seedRandomness()
  drawArt()
}

function handleKeypress(event: KeyboardEvent) {
  if (event.key === "s") {
    const maxSize = 5500
    const res = windowResolution(SIZE_RATIO, maxSize, maxSize)
    takeScreenshot(res.width / devicePixelRatio, res.height / devicePixelRatio, gl, program)
  }
}
